import React from 'react'
// eslint-disable-next-line react/no-deprecated
import { render } from 'react-dom'

import * as Sentry from '@sentry/react'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import { SENTRY_IGNORE_ERRORS } from '@emmacare/common/config/sentry'
import { initDatadogRum } from '@emmacare/common/services/datadogRum'

import App from 'src/components/App'
import { CURRENT_PORTAL_VERSION } from 'src/constants'

const envTracesSampleRate = parseFloat(process?.env?.TRACES_SAMPLE_RATE)
const replaysOnErrorSampleRate = parseFloat(
  process?.env?.REPLAY_ERROR_SAMPLE_RATE
)
const disableSentry = process?.env?.DISABLE_SENTRY || false
const disableDatadogRum = process?.env?.DISABLE_DATADOG_RUM || false

const tracesSampleRate =
  isNaN(envTracesSampleRate) ||
  envTracesSampleRate < 0 ||
  envTracesSampleRate > 1.0
    ? 0.05
    : envTracesSampleRate

const maintenance = false

// TODO separate debug/logger package
if (!disableSentry) {
  Sentry.init({
    environment: process.env.ENVIRONMENT_TYPE || 'local',
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    dsn: 'https://2c53d15e6998439b9631d7b5d26e89c6@o259501.ingest.sentry.io/1455199',
    replaysSessionSampleRate: tracesSampleRate,
    replaysOnErrorSampleRate,
    integrations: [
      // todo: change to Sentry.reactRouterV6BrowserTracingIntegration after react router update
      // https://docs.sentry.io/platforms/javascript/guides/react/
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false
      }),
      Sentry.replayCanvasIntegration()
    ],
    tracePropagationTargets: [
      'dev.emmacare-dev.com',
      'dev-api.emmacare-dev.com',
      'sandbox.emmacare-dev.com',
      'sandbox-api.emmacare-dev.com',
      'preprod.emmacare-dev.com',
      'preprod-api.emmacare-dev.com',
      'cdn.emmacare.com',
      'api.emmacare.com'
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate
  })
}

if (!disableDatadogRum) {
  initDatadogRum({
    applicationId: 'bfe9195a-f3fa-4218-8979-18107f17dc10',
    clientToken: 'pub79f5f0a9e08b3c00e7539be6c0ab08f3',
    site: 'us5.datadoghq.com',
    service: 'care-portal',
    env: process.env.ENVIRONMENT_TYPE || 'local',
    version: CURRENT_PORTAL_VERSION
  })
}

const container = document.getElementById('app')
render(<App maintenance={maintenance} />, container)
